import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bcf1124"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["data-clipboard-text"]
const _hoisted_9 = {
  key: 0,
  class: "note"
}

import { ref, onUpdated } from 'vue';
import { storeToRefs } from 'pinia';
import { useShare } from '@/store';
import { useI18n } from 'vue-i18n';
import ClipboardJS from 'clipboard';

export default /*#__PURE__*/_defineComponent({
  __name: 'Share',
  setup(__props) {

const { isShareVisible, isCopied } = storeToRefs(useShare());
const { updateIsShareVisible, updateIsCopied } = useShare();
const lang: string = document.documentElement.lang;
const apps: { [key: string]: string[] } = {
  tw: ['fb', 'line', 'twitter'],
  id: ['fb', 'whatsapp'],
  th: ['fb', 'line', 'twitter'],
  vn: ['fb'],
};
const link = encodeURI(window.location.origin);
const share = async (method: string, event: Event) => {
  if (navigator && navigator.share) {
    event.preventDefault();
    await navigator.share({
      url: link,
    });
    window.gtag('event', 'share', {
      method: 'mobile',
    });
  } else {
    window.gtag('event', 'share', {
      method,
    });
  }
};
const copyUrl = () => {
  const clipboard = new ClipboardJS('.copy');
  clipboard.on('success', () => {
    updateIsCopied(true);
    setTimeout(() => {
      updateIsCopied(false);
    }, 3000);
    window.gtag('event', 'share', {
      method: 'copy',
    });
  });
};
const { t } = useI18n();
const el = ref<null | HTMLElement>(null);
onUpdated(() => {
  el.value = document.querySelector('#J-sitebar');
});

return (_ctx: any,_cache: any) => {
  return (_unref(isShareVisible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(['content', { hasTopbar: el.value }])
        }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('SHARE_TITLE')), 1),
          _createElementVNode("div", _hoisted_3, [
            (apps[_unref(lang)].includes('fb'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "share share--fb",
                  href: `https://www.facebook.com/sharer/sharer.php?u=${_unref(link)}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (share('Facebook', $event)))
                }, _toDisplayString(_unref(t)('SHARE_FB')), 9, _hoisted_4))
              : _createCommentVNode("", true),
            (apps[_unref(lang)].includes('whatsapp'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "share share--whatsapp",
                  href: `https://wa.me/?text=${_unref(link)}`,
                  "data-action": "share/whatsapp/share",
                  target: "_blank",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (share('Whatsapp', $event)))
                }, _toDisplayString(_unref(t)('SHARE_WHATSAPP')), 9, _hoisted_5))
              : _createCommentVNode("", true),
            (apps[_unref(lang)].includes('line'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "share share--line",
                  href: `https://line.me/R/msg/text/?${_unref(link)}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (share('Line', $event)))
                }, _toDisplayString(_unref(t)('SHARE_LINE')), 9, _hoisted_6))
              : _createCommentVNode("", true),
            (apps[_unref(lang)].includes('twitter'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  class: "share share--twitter",
                  href: `https://twitter.com/intent/tweet?url=${_unref(link)}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (share('Twitter', $event)))
                }, _toDisplayString(_unref(t)('SHARE_TWITTER')), 9, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "close",
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(updateIsShareVisible)(false)))
          }),
          _createElementVNode("button", {
            class: "copy",
            type: "button",
            "data-clipboard-text": _unref(link),
            onClick: copyUrl
          }, null, 8, _hoisted_8),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_unref(isCopied))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)('SHARE_COPIED')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})